var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { gql } from '@apollo/client';
export var RESOLVE_URL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query ResolveURL($url: String!, $storeFrom: String) {\n        urlResolver(url: $url, storeFrom: $storeFrom) {\n            id\n            relative_url\n            redirectCode\n            type\n            sku\n        }\n    }\n"])));
export default {
  resolveUrlQuery: RESOLVE_URL
};